import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonButtonNextComponent } from './button-next.component';

import { IconsModule } from '@monsido/angular-shared-components';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    declarations: [
        MonButtonNextComponent,
    ],
    imports: [
        CommonModule,
        IconsModule,
        NgbTooltipMfeModule,
    ],
    exports: [MonButtonNextComponent],
})
class ButtonNextModule { }

export { ButtonNextModule as MonButtonNextModule };
